<template>
  <v-container fluid class="home pt-0">
    <v-row>
      <v-col class="pt-0">
        <v-notification showAreaType="top"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
        v-for="(item, index) in items"
        :key="index"
      >
        <v-clickable-card
          :detail="item.detail + sampleAccountDetailMessages[item.id]"
          primary
          :disabled="item.disabled"
          @click="$router.push(item.to)"
        >
          <template v-slot:heading>
            <v-img
              :class="item.avatarClass"
              :src="item.avatar"
            />
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
              <v-list-item-subtitle class="subtitle">{{item.subtitle}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:content>
            <v-img
              class="image mt-0"
              :src="item.src"
              height="233px"
            ></v-img>
          </template>
        </v-clickable-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import VClickableCard from '@/components/molecules/ClickableCard'
import VNotification from '@/components/molecules/Notification'

export default {
  components: {
    VClickableCard,
    VNotification
  },

  data() {
    return {
      hoverdId: null,
      items: [
        {
          id: 1,
          src: require('@/assets/img/create_print.png'),
          avatarClass: "avatar-hight",
          avatar: require('@/assets/img/f_f_business_91_s512_f_business_91_0nbg.png'),
          title: '問題作成',
          detail: '問題作成画面に遷移します。',
          disabled: false,
          to: '/teacher/create_print'
        },
        {
          id: 2,
          src: require('@/assets/img/saved_prints.png'),
          avatarClass: "avatar-hight",
          avatar: require('@/assets/img/f_f_business_53_s512_f_business_53_0nbg.png'),
          title: '保存問題',
          detail: '保存済みの問題を表示します。',
          disabled: this.$store.getters['user/isSampleAccount'],
          to: '/teacher/saved_prints'
        },
      ],
    }
  },

  mounted() {
    this.$gtag.pageview({
      page_path: '/',
      page_title: "ホーム画面"
    })
  },

  computed: {
    sampleAccountDetailMessages() {
      if (!this.$store.getters['user/isSampleAccount']) return {1: '', 2: ''}
      return {
        1: '<br>出力できる範囲をゲットスルー2600のID １～40、教科書単語は開隆中3 PROGRAM1の50語（連語含む）に制限してあります。',
        2: '<br>サンプルでは問題の保存はできません。'
      }
    },
    isSampleAccount() {
      return this.$store.getters['user/isSampleAccount']
    }
  },
}
</script>

<style lang="stylus" scoped>
.text
  color #313131
  box-shadow 0px 2px 0px 0px #2a5594
  display inline-block

.avatar-hight
  max-width 35px
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.avatar-wide
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.image
  margin-top 10px
  box-shadow 0px 0px 3px 0px #b3b3b3
</style>
